import React, { useContext } from "react";
import LoadingOverlay from "react-loading-overlay";
import { Context } from "../../context/globalContext";

// Components
import Navbar from "../../components/Navbar";
import FrontCreditoIcon from "../../assets/navbar/Front_Credito_on_light_blue.svg";
import * as S from "./styles";

import ListCredit from "../../components/ListCredit";

const CreditList = () => {
  const { loadingOverlayActive, setLoadingOverlayActive } = useContext(Context);
  const { loadingOverlayText, setLoadingOverlayText } = useContext(Context);

  return (
    <S.ContainerPage>
      <LoadingOverlay
        active={loadingOverlayActive}
        spinner
        text={loadingOverlayText}
      >
        <Navbar />
        <S.Wrapper>
          <S.Header>
            <S.BoxUser>
              <S.Image src={FrontCreditoIcon} />
              <div>
                <S.Title>Front de Crédito</S.Title>
                <S.Description>Filtros gerais de busca</S.Description>
              </div>
            </S.BoxUser>
          </S.Header>

          <ListCredit />
        </S.Wrapper>
      </LoadingOverlay>
    </S.ContainerPage>
  );
};

export default CreditList;
